import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';
import Modal from 'react-bootstrap/Modal';
import DateAndTime from '../date_and_time/date_and_time';
import ShareSection from '../share_section/share_section';

const ConfirmationModal: React.FC = () => {
  const { event, showConfirmationModal, setShowConfirmationModal, isSignedIn, userDetails } =
    useContext(EventDetailsContext);

  if (!isSignedIn || !event) return null;

  return (
    <Modal
      show={showConfirmationModal}
      onHide={() => setShowConfirmationModal(false)}
      animation={false}
    >
      <Modal.Header closeButton className='ps-45 pe-4'>
        <h2 className='modal-title fs-2' data-testid='confirmation-modal-title'>
          Thank you for registering!
        </h2>
      </Modal.Header>
      <Modal.Body className='p-0'>
        {/* eslint-disable-next-line max-len*/}
        <div className='fw-bold d-flex flex-column justify-content-center align-items-center px-45 pt-4 pb-2'>
          <i className='fal icon-check-circle fs-2' aria-hidden='true' />
          <p className='text-center'>
            You are attending {event.attendance_type === 'in_person' ? 'in person' : 'online'}:
          </p>
        </div>

        <div className='bg-primary text-center pt-4 pb-3'>
          <p className='text-white px-45'>
            <span className='fw-bold text-capitalize'>{event?.title}</span>
            <br />
            <DateAndTime />
            <span> | {event.attendance_type === 'in_person' ? event.location : 'Online'}</span>
          </p>
        </div>
        {event.attendance_type === 'in_person' && (
          <>
            <p className='px-48 pt-4 pb-3 text-center'>
              See you at the event! You&apos;ll receive a confirmation email to{' '}
              <span className='fw-bold'>{userDetails.email}</span> shortly with further information.
            </p>
            <div className='px-48 pt-1 pb-48'>
              <ShareSection />
            </div>
          </>
        )}

        {event.attendance_type === 'virtual' && (
          <div>
            <p className='px-48 pt-4 text-center'>
              See you at the event!
              <br />
              {new Date(event.starts_at).getTime() - Date.now() > 60 * 60 * 1000
                // eslint-disable-next-line max-len
                ? "You'll receive a registration email now and a reminder one hour before the event."
                : "You'll receive a registration email shortly."}
            </p>
            <p className='px-48 text-center'>
              You can also return to this event page to join when it starts.
            </p>
            <div className='px-48 pt-35 py-48'>
              <ShareSection />
            </div>
            <p className='fst-italic text-center px-48 pt-3 pb-3'>
              The event will be recorded. <br />A link to the recording will be emailed to you after
              the event.
            </p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
